import { zodResolver } from '@hookform/resolvers/zod'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { CseInput } from '../../../lib/types/models/cse/cse'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'
import ValidationButtons from '../../elements/validation-buttons'
import CseAddressFormSection from './cse-address-form-section'
import CseBasicDetailsFormSection from './cse-basic-details-form-section'
import CseCommentFormSection from './cse-comment-form-section'
import CseExtraOptionFormSection from './cse-extra-option-form-section'
import CseFacturationAndInsuranceSection from './cse-facturation-and-insurance-section'
import CseGeneralContactInfoFormSection from './cse-general-contact-info-form-section'
import CseNumberOfEmployeesFormSection from './cse-number-of-employees-form-section'
import { CSE_FORM_SCHEMA } from './utils'

const CseForm = ({ defaultValues, ...validationButtonProps }: BaseFormProps<CseInput, true>) => {
  const { t } = useTranslate()
  const form = useForm<CseInput>({
    resolver: zodResolver(CSE_FORM_SCHEMA(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className="flex gap-4 w-full">
          <div className="flex flex-col gap-4 w-full">
            <CseBasicDetailsFormSection />
            <CseFacturationAndInsuranceSection />
            <CseExtraOptionFormSection />
          </div>
          <div className="flex flex-col gap-4 w-full">
            <CseAddressFormSection />
            <CseGeneralContactInfoFormSection />
            <CseCommentFormSection />
            <CseNumberOfEmployeesFormSection />
            <div className="flex items-center justify-between px-3">
              <Typography variant="tag" className="text-grey">
                Le CSE verse une participation à ses ayants droit *
              </Typography>
              <div className="flex items-center gap-3">
                <FormField
                  control={form.control}
                  name={'councilAllowance'}
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <ControlledRadioInput
                          {...field}
                          label={'Oui'}
                          checked={field.value === true}
                          onCheck={() =>
                            form.setValue('councilAllowance', true, { shouldValidate: true })
                          }
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name={'councilAllowance'}
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <ControlledRadioInput
                          {...field}
                          label={'Non'}
                          checked={field.value === false}
                          onCheck={() =>
                            form.setValue('councilAllowance', false, { shouldValidate: true })
                          }
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default CseForm
